import React from 'react';
import { IrrigationControl } from '../components/IrrigationControl';

export const IrrigationPage = () => {
    return (
        <div className="p-4 md:p-6 pb-24" data-testid="irrigation-page">
            <IrrigationControl />
        </div>
    );
};

export default IrrigationPage;
